import { enumKeysToArray } from '@/utils/enum'
import { makeServicesTypes } from '@/core/container/makeServicesTypes'

enum SERVICES {
  TemplatesBulkManager,
  TemplatesByCategoryColumnServiceFactory,
  TemplatesColumnServiceFactory,
  SubAccountsColumnServiceFactory,
  TemplatesFormService,
  TemplatesSelectColumnServiceFactory,
  TemplatesEditCategoryFormService,
  TemplateCategoriesDeleteFormService,
  TemplateCategoriesFormService,
  TemplatesFilterServiceFactory,
  TemplatesService,
  TemplatesRepository,
  TemplateCategoriesService,
  TemplateCategoriesRepository,
  TemplatesTableExpandService,
  EmailTemplateRepository,
  EmailTemplateColumnService,
  EmailTemplatesFaceterService,
  EmailTemplatesFilterServiceFactory,
  TemplateCategoriesPreloaderService,
  TemplateCategoriesResolverService,
  TemplateEmailFormService,
  TemplatesFaceterService,
  EmailTemplatesService,
}

export type TemplatesServices = keyof typeof SERVICES

export const TEMPLATES_SERVICE_TYPES: Record<TemplatesServices, symbol> = makeServicesTypes<TemplatesServices>(
  enumKeysToArray<TemplatesServices>(SERVICES),
)
